import { gql, makeVar, TypedDocumentNode, useQuery } from '@apollo/client'

import { findActiveStoreView, getStoreViews } from '@emico/storeviews'

import {
  StoreConfigCurrencyCodeQuery,
  StoreConfigCurrencyCodeQueryVariables,
} from './currencyCode.generated'

// Only used as fallback while loading the storeConfig
const DEFAULT_CURRENCY_CODE = 'EUR'

const defaultCode = findActiveStoreView(getStoreViews())
  ?.defaultDisplayCurrencyCode

export const currencyCode = makeVar<string>(
  defaultCode ?? DEFAULT_CURRENCY_CODE,
)

const currencyCodeQuery = gql`
  query StoreConfigCurrencyCode {
    storeConfig {
      defaultDisplayCurrencyCode
    }
  }
` as TypedDocumentNode<
  StoreConfigCurrencyCodeQuery,
  StoreConfigCurrencyCodeQueryVariables
>

let isHookCalled = false
export function useFetchDefaultCurrencyCode() {
  const { data } = useQuery(currencyCodeQuery)
  isHookCalled = true

  if (data?.storeConfig?.defaultDisplayCurrencyCode) {
    currencyCode(data?.storeConfig?.defaultDisplayCurrencyCode)
  }
}

if (process.env.NODE_ENV === 'development') {
  setTimeout(() => {
    if (!isHookCalled) {
      throw new Error(
        'Make sure to include the useFetchDefaultCurrencyCode hook',
      )
    }
  }, 2000)
}
